var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { ProtoGraphLoaderNamespace } from "../config";
import { log } from "../core/helpers";
function init(core) {
    core.defineHandler('object', "layout", new Layout(core));
}
function defineGrammar(grammarBuilder) {
    grammarBuilder.defineGrammarObject("layout", "Layout", "'layout'i {return {type: \"object\", keyword: \"layout\", parameters: []} }");
}
function defineAutoComplete(autoCompleteRulesBuilder) {
    autoCompleteRulesBuilder.defineLineStart({
        firstWord: "layout",
        displayText: "layout\n",
        description: "Define properties for the layout algorithm."
    });
}
var loader = window[ProtoGraphLoaderNamespace];
var declaration = {
    name: "object_layout",
    exec: init,
    grammar: defineGrammar,
    autocomplete: defineAutoComplete
};
loader.register(declaration);
var Layout = (function () {
    function Layout(core) {
        this.core = core;
        this.active = true;
        this.keyword = "layout";
        this.data = {
            name: 'breadthfirst',
            directed: true,
            animate: false && !!this.core.config.animate_duration,
        };
        if (!this.core.cy)
            throw Error("Core Cytoscape not Initialized");
        this.layout = this.core.cy.layout(this.data);
        this.layout.run();
    }
    Layout.prototype.reset = function () {
        this.active = true;
    };
    Layout.prototype.disable = function () {
        this.active = false;
    };
    Layout.prototype.updateLayout = function (data) {
        if (!this.core.cy)
            throw Error("Core Cytoscape not Initialized");
        try {
            this.layout = this.core.cy.layout(data);
        }
        catch (_a) {
            log("Unsupported Layout Property", this.data);
            this.layout = null;
            throw Error("Unsupported Layout Property");
        }
    };
    Layout.prototype.generateAutoComplete = function (data) {
        var booleanOptions = [
            { insertText: "true", displayText: "true" },
            { insertText: "false", displayText: "false" }
        ];
        var extras = [];
        if (data.name === "breadthfirst" || data.name === "grid" || data.name === "circle" || data.name === "concentric") {
            extras = extras.concat([
                { insertText: "spacingFactor", displayText: "spacingFactor", description: "(Default 1.75) Positive spacing factor, larger => try more space between nodes." },
                { insertText: "avoidOverlap", displayText: "avoidOverlap", description: "(Default true) Try to prevents node overlap; may overflow boundingBox if not enough space.", options: booleanOptions }
            ]);
        }
        if (data.name === "breadthfirst") {
            extras = extras.concat([
                { insertText: "directed", displayText: "directed", description: "(Default true) Whether the tree is directed downwards.", options: booleanOptions },
                { insertText: "circle", displayText: "circle", description: "(Default false) Put depths in concentric circles.", options: booleanOptions },
                { insertText: "grid", displayText: "grid", description: "(Default false) Whether to create an even grid into which the DAG is placed (not compatible with circle)", options: booleanOptions },
                { insertText: "nodeDimensionsIncludeLabels", displayText: "nodeDimensionsIncludeLabels", description: "(Default false) Whether to include the label when calculating node bounding boxes for the layout algorithm", options: booleanOptions },
                { insertText: "maximal", displayText: "maximal", description: "(Default false) Whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only).", options: booleanOptions }
            ]);
        }
        var res = __spreadArray(__spreadArray([
            {
                insertText: "name", displayText: "name: [algorithm name]", description: "Specifies the layout algorithm for rendering the graph.", options: [
                    { insertText: "random", displayText: "random", description: "Puts nodes in random positions." },
                    { insertText: "preset", displayText: "preset", description: "Puts nodes in the positions you specify manually." },
                    { insertText: "grid", displayText: "grid", description: "Puts nodes in a well-spaced grid." },
                    { insertText: "circle", displayText: "circle", description: "Puts nodes in a circle." },
                    { insertText: "concentric", displayText: "concentric", description: "Positions nodes in concentric circles, based on a metric that you specify to segregate the nodes into levels." },
                    { insertText: "breadthfirst", displayText: "breadthfirst", description: "Puts nodes in a hierarchy, based on a breadthfirst traversal of the graph. It is best suited to trees and forests in its default top-down mode, and it is best suited to DAGs in its circle mode." },
                    { insertText: "cose", displayText: "cose", description: "The cose (Compound Spring Embedder) layout uses a physics simulation to lay out graphs. It works well with noncompound graphs and it has additional logic to support compound graphs well." },
                ]
            }
        ], extras), [
            {
                insertText: "animate", displayText: "animate: [true / false]", options: booleanOptions
            },
            { insertText: "animationDuration", displayText: "animationDuration: [number]" },
            { insertText: "padding", displayText: "padding: [number]", description: "Extra spaces when fitting zoom." },
        ]);
        return res;
    };
    Layout.prototype.propertiesAutoComplete = function () {
        return this.generateAutoComplete(this.data);
    };
    Layout.prototype.execute = function (_a) {
        var _this = this;
        var line = _a.line, properties = _a.properties;
        this.active = true;
        var data = __assign(__assign({}, this.data), properties);
        this.updateLayout(data);
        this.data = data;
        var type = "object_result";
        return {
            type: type,
            query_object: [],
            keyword: line.keyword,
            data: line,
            extra: {},
            propertiesAutoComplete: function () { return _this.generateAutoComplete(_this.data); }
        };
    };
    Layout.prototype.onChange = function () {
        var _a;
        if (this.active) {
            if (!this.core.cy)
                throw Error("Core Cytoscape not Initialized");
            this.updateLayout(this.data);
            (_a = this.layout) === null || _a === void 0 ? void 0 : _a.run();
        }
    };
    return Layout;
}());
export { Layout };
export default declaration;
